export default function Choise({ question, onAnswer, selectedAnswer }) {
  return (
    <div>
      <p style={{ fontWeight: "600", fontSize: "18px", marginBottom: "20px" }}>
        {question.text}
      </p>

      <div className="d-flex flex-column gap-3">
        {(question.choices || []).map((choice, idx) => {
          const isSelected = selectedAnswer === choice.id;

          return (
            <div
              key={choice.id ?? `choice-${idx}`}
              onClick={() => onAnswer(question.id, choice.id)}
              className="d-flex align-items-center justify-content-between px-4 py-3 rounded option-card"
              style={{
                cursor: "pointer",
                border: "2px solid",
                borderColor: isSelected ? "var(--brand-200)" : "#ddd",
                backgroundColor: isSelected ? "#f1faff" : "#fff",
                transition: "all 0.3s ease",
                boxShadow: isSelected
                  ? "0 2px 10px rgba(0, 123, 143, 0.1)"
                  : "0 2px 6px rgba(0,0,0,0.05)",
                boxSizing: "border-box",
              }}
              onMouseEnter={(e) => {
                if (!isSelected) {
                  e.currentTarget.style.backgroundColor = "#f7f7f7";
                }
              }}
              onMouseLeave={(e) => {
                if (!isSelected) {
                  e.currentTarget.style.backgroundColor = "#fff";
                }
              }}
            >
              <span
                style={{
                  fontSize: "16px",
                  fontWeight: "500",
                  color: isSelected ? "var(--brand-200)" : "#333",
                }}
              >
                {choice.text}
              </span>

              <span
                style={{
                  width: "18px",
                  height: "18px",
                  minWidth: "18px",
                  minHeight: "18px",
                  borderRadius: "50%",
                  border: `2px solid ${
                    isSelected ? "var(--brand-200)" : "#ccc"
                  }`,
                  backgroundColor: isSelected
                    ? "var(--brand-200)"
                    : "transparent",
                  transition: "all 0.3s ease",
                }}
              ></span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
